<tad-dialog-container [dialogTitle]="'Saved Institutions'">
  <div *ngIf="institutions$ | async as institutions" class="dialog-content">
    <div class="institution-list">
      <ng-container *ngFor="let item of institutions">
        <tad-institution-card
          class="institution-card"
          [added]="(compareInstitutionIds$ | async)?.includes(item.id)"
          [saved]="true"
          [routerLink]="'/institution/' + item.id"
          [institution]="item"
          [showRemove]="true">
        </tad-institution-card>
      </ng-container>
    </div>

    <div *ngIf="!institutions?.length" class="text-center mt-hg">
      Your saved institutions list is empty
    </div>
  </div>
</tad-dialog-container>
